module.exports = __webpack_public_path__ + "img/qr-slide-mob-2.76f0017a.png";